// @flow
import {
  PLANS_UPDATED,
  PLANS_UPDATING,
  WIZARD_PASSED,
  WIZARD_SAVING,
  WIZARD_SAVED
} from '../actions/wizard.actions';
import { ME_UPDATE } from '../actions/user.actions';

export const WIZARD_STEPS = ['select-web-property', 'select-plan', 'get-client', 'seo-perfomance'];

export const getCurrentStep = ({ passed }: { passed: Array<string> }) => {
  return WIZARD_STEPS.reduce((result, step) => {
    if (result) return result;
    if (!~passed.indexOf(step)) return step;
    return result;
  }, null);
};

export const isWizardPassed = ({ passed = [] }: { passed: Array<string> }) => {
  return !WIZARD_STEPS.reduce((r, s) => r || !~passed.indexOf(s), false);
};

export const getNextStep = ({ passed = [] }: { passed: Array<string> }) => {
  const currentStep = getCurrentStep({ passed });
  const currentIndex = currentStep ? WIZARD_STEPS.indexOf(currentStep) : -1;
  return WIZARD_STEPS[currentIndex];
};

const initialState = {
  steps: [].concat(WIZARD_STEPS),
  passed: [],
  next: null,
  plansUpdating: true,
  plans: [],
  wizardSaving: false
};

export default (state: Object = initialState, action: { type: String, data: any }) => {
  switch (action.type) {
    case WIZARD_PASSED:
      return {
        ...state,
        passed: action.data,
        next: getNextStep({ passed: action.data })
      };
    case PLANS_UPDATING:
      return {
        ...state,
        plansUpdating: true,
        plans: []
      };
    case PLANS_UPDATED:
      return {
        ...state,
        plansUpdating: false,
        plans: action.data
      };

    case WIZARD_SAVING:
      return {
        ...state,
        wizardSaving: true
      };

    case WIZARD_SAVED:
      return {
        ...state,
        wizardSaving: false
      };

    default:
      const next = getNextStep({ passed: state.passed });
      return {
        ...state,
        next
      };
  }
};



// WEBPACK FOOTER //
// ./src/reducers/wizardReducer.js